import React, { useEffect } from "react";
import "../../CSS/NewOnboading/OnboadingLoader.css";

export default function OnboardingLoader({ message = "Processing..." }) {
  useEffect(() => {
    return () => {
    };
  }, []);

  return (
    <div className="onboarding-loader-overlay">
      <div className="loader-container">
        <div className="loader-icon">
          <div className="review-star">
            <div className="star-pulse"></div>
          </div>
          <div className="star-orbit">
            <div className="small-star"></div>
            <div className="small-star"></div>
            <div className="small-star"></div>
            <div className="small-star"></div>
          </div>
        </div>
        <div className="loading-text">{message}</div>
      </div>
    </div>
  );
}
